import { firebase } from '@/services'
import { useCallback, useEffect, useState } from 'react'
import { userHasSocialLogin } from './utils'

export const useFirebaseUser = () => {
  const [user, setUser] = useState(() => {
    return firebase.auth.currentUser
  })

  useEffect(() => {
    const unsubscribe = firebase.auth.onAuthStateChanged((user) => {
      setUser(user)
    })

    return unsubscribe
  }, [])

  return user
}

export const useUserHasSocialLogin = () => {
  const [result, setResult] = useState({ hasSocialLogin: false, signInMethods: [] })

  const setUserHasSocialLogin = useCallback(async () => {
    const result = await userHasSocialLogin()

    setResult(result)
  }, [])

  useEffect(() => {
    setUserHasSocialLogin()
  }, [])

  return result
}